let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9KbcQ")).then(() => parcelRequire('7YOHo'));